import React from "react";

const Form = ({ children }) => {
  return <>{children}</>;
};

export default Form;
